/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutResponse } from '../../models/put-response';
import { TenantUpdate } from '../../models/tenant-update';

export interface UpdateTenant$Params {
  tenantId: string;
      body?: TenantUpdate
}

export function updateTenant(http: HttpClient, rootUrl: string, params: UpdateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
  const rb = new RequestBuilder(rootUrl, updateTenant.PATH, 'put');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PutResponse>;
    })
  );
}

updateTenant.PATH = '/tenants/{tenantId}';
